import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { Constants } from '../Constants';
import { BaseApiDataResponse } from '../Models/ApiData';
import {
    AuthenticationResponse,
    GrantType,
    LoginRequest,
    RefreshRequest,
    ResetPasswordRequest,
} from '../Models/Authentication/AuthResponse';
import { BaseDataService } from './Base/BaseDataService';

const LoginEndpoints = {
    LOGIN: '/api/v1/back/login',
    REFRESH: 'api/v1/back/refresh',
    LOGOUT: 'api/v1/back/logout',
    SEND_PASSWORD_REQUEST: '/api/v1/back/password/request',
    RESET_PASSWORD: '/api/v1/back/password/reset',
};

export interface IAuthDataService {
    login: (
        email: string,
        password: string,
        cts: XHRRequestCanceler
    ) => Promise<AuthenticationResponse>;
    logout: () => Promise<BaseApiDataResponse>;
    refresh: (refreshToken: string, cts?: XHRRequestCanceler) => Promise<AuthenticationResponse>;
    sendPasswordRequest: (email: string, cts: XHRRequestCanceler) => Promise<BaseApiDataResponse>;
    resetPassword: (
        token: string,
        email: string,
        newPassword: string,
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;
}

class AuthDataService extends BaseDataService implements IAuthDataService {
    async login(
        email: string,
        password: string,
        cts: XHRRequestCanceler
    ): Promise<AuthenticationResponse> {
        const body: LoginRequest = {
            email: email,
            password: password,
            grant_type: GrantType.Password,
            client_id: Constants.CLIENT_ID,
            client_secret: Constants.CLIENT_SECRET,
        };
        return this.post<AuthenticationResponse>(LoginEndpoints.LOGIN, body, cts);
    }

    async logout(): Promise<BaseApiDataResponse> {
        return this.post<BaseApiDataResponse>(LoginEndpoints.LOGOUT, {});
    }

    async refresh(refreshToken: string, cts?: XHRRequestCanceler): Promise<AuthenticationResponse> {
        const body: RefreshRequest = {
            refresh_token: refreshToken,
            client_id: Constants.CLIENT_ID,
            client_secret: Constants.CLIENT_SECRET,
        };
        return this.post<AuthenticationResponse>(LoginEndpoints.REFRESH, body, cts, {
            checkError: false,
        });
    }

    async sendPasswordRequest(
        email: string,
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> {
        const body = {
            email: email,
        };

        return this.post<AuthenticationResponse>(LoginEndpoints.SEND_PASSWORD_REQUEST, body, cts);
    }

    async resetPassword(
        token: string,
        email: string,
        newPassword: string,
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> {
        const body: ResetPasswordRequest = {
            email: email,
            new_password: newPassword,
            validation_code: token,
        };
        return this.post<BaseApiDataResponse>(LoginEndpoints.RESET_PASSWORD, body, cts);
    }
}

const AuthDataServiceName: string = 'AuthDataService';

export { AuthDataService, AuthDataServiceName };
